import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { isEmpty } from 'lodash';
import 'react-datepicker/dist/react-datepicker.css';

const DateRangeSearch = ({
  onDateChangeHandler,
  onSearchHandler,
  clearDates,
  searchFields,
  value,
  handleDateChangeRaw,
}) => {
  return (
    <div>
      <Form onSubmit={onSearchHandler}>
        <Form.Group widths='equal'>
          <Form.Field>
            <label htmlFor='startDate'>Start Date</label>
            <DatePicker
              id='startDate'
              style={{ padding: '0', width: '100%' }}
              selected={
                isEmpty(value.startDate)
                  ? searchFields.startDate
                  : value.startDate
              }
              onChange={date => onDateChangeHandler('startDate', date)}
              dateFormat='YYYY-MM-DD'
              name='startDate'
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor='endDate'>End Date</label>
            <DatePicker
              id='endDate'
              style={{ padding: '0', width: '100%' }}
              selected={
                isEmpty(value.endDate)
                  ? searchFields.endDate
                  : value.endDate
              }
              onChange={date => onDateChangeHandler('endDate', date)}
              dateFormat='YYYY-MM-DD'
              name='endDate'
              onChangeRaw={handleDateChangeRaw}
              required
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor='searchButton'>Actions</label>
            <Button color='green' id='searchButton' inverted>
              Search
            </Button>
            <Button color='green' type='button' onClick={clearDates} inverted>
              Clear
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
      <br />
      <br />
    </div>
  );
};

DateRangeSearch.propTypes = {
  onDateChangeHandler: PropTypes.func,
  onSearchHandler: PropTypes.func,
  clearDates: PropTypes.func,
  searchFields: PropTypes.shape({
    startDate: PropTypes.object,
    endDate: PropTypes.object,
  }),
  value: PropTypes.shape({
    startDate: PropTypes.object,
    endDate: PropTypes.object,
  }),
  handleDateChangeRaw: PropTypes.func,
};

export default DateRangeSearch;
